<template>
    <div :style="{ display: inline ? 'inline' : 'block' }">
        <div
            v-if="label !== null"
            class="kgr-inputGroup__label"
        >
            {{ label }}
        </div>
        <kgr-loading
            v-if="loading"
            inline
        />
        <select
            v-else
            ref="select"
            v-model="selection"
            class="kgr-select"
            :style="{ width: inline ? 'initial': '' }"
            :disabled="disabled"
            @change="update()"
        >
            <option
                v-if="!noNullOption"
                :value="null"
                class="kgr-select__option"
            >
                {{ $t(defaultText || nullDefault) }}
            </option>
            <optgroup
                v-for="optGroup in optGroups"
                :key="optGroup.label + '-group'"
                :label="$t(optGroup.label)"
            >
                <option
                    v-for="option in optGroup.options"
                    :key="optGroup.label + '-' + displayOption(option)"
                    :value="option"
                    :disabled="option.disabled"
                    class="kgr-select__option"
                >
                    {{ displayOption(option) }}
                </option>
            </optgroup>
        </select>
        <div
            v-if="error != null"
            class="kgr-color kgr-color--error"
        >
            {{ error }}<br />
        </div>
    </div>
</template>

<script>
import Loading from '../../Loading';

export default {
    components: {
        'kgr-loading': Loading,
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: null,
        },
        defaultText: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        optGroups: {
            type: Array,
            required: true,
        },
        display: {
            type: String,
            required: false,
            default: null,
        },
        noNullOption: {
            type: Boolean,
            required: false,
            default: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            selection: null,
            nullDefault: 'pleaseChooseAnOption',
        }
    },
    watch: {
        value(newValue) {
            this.selection = newValue;
        },
        optGroups() {
            if (null !== this.selection && !this.optGroups.map(g => g.options).includes(this.selection)) {
                this.selection = null;
                this.update();
            }
        },
    },
    mounted() {
        this.selection = typeof this.value === 'undefined' ? null : this.value;
    },
    methods: {
        update() {
            this.$emit('input', this.selection);
            this.$nextTick(() => {
                this.$emit('post-input', this.selection);
            });
        },
        displayOption(option) {
            if (this.display) {
                return typeof option[this.display] === 'function' ? option[this.display]() : option[this.display];
            }

            return this.$t(option);
        },
    },
}
</script>
